class CompanionMaterialDetailItem {
    private readonly _name: string;
    private readonly _value: string;
    private readonly _companionMaterialDetailItems: Array<CompanionMaterialDetailItem> = new Array<CompanionMaterialDetailItem>();
    private readonly _attributes: Map<string, string> = new Map<string, string>();

    constructor(name: string, value: string) {
        this._name = name;
        this._value = value;
    }

    get name(): string {
        return this._name;
    }

    get attributes(): Map<string, string> {
        return this._attributes;
    }

    get value(): string {
        return this._value;
    }

    get companionMaterialDetailItems(): Array<CompanionMaterialDetailItem> {
        return this._companionMaterialDetailItems;
    }

    addAttribute(key: string, value: string) {
        this._attributes.set(key, value);
    }

    addCompanionMaterialDetailItem(companionMaterialDetailItem: CompanionMaterialDetailItem) {
        this._companionMaterialDetailItems.push(companionMaterialDetailItem);
    }
}

export default CompanionMaterialDetailItem;
